import PropTypes from 'prop-types';

export default {
  showPrintButton: PropTypes.bool,
  classNamesPrintButton: PropTypes.string,
  analyticsTitle: PropTypes.string,
};
